// extracted by mini-css-extract-plugin
export default {"text":"style_text__VPdwM","active":"style_active__kC0Dx","grid_gap":"style_grid_gap__h1--2"};